import {format} from "date-fns";
import { enUS } from 'date-fns/locale';
import useApi from "../../api";
import {useQuery} from "react-query";
import queryConfig from "../../util/queryConfig";
import Throbber from "../throbber/Throbber";
import Error from "../error/Error";
import {useModal} from "../modal/useModal";
import GenerateApiKeyModal from "./modals/GenerateApiKeyModal";
import RemoveApiKeyModal from "./modals/RemoveApiKeyModal";
import EditApiKeyModal from "./modals/EditApiKeyModal";
import {ReactComponent as BinSVG} from '../../../img/icons/bin.svg';
import { QueryKey } from '../../constants/queryKey';

const ApiKeys = () => {
    const {getApiKeys} = useApi();
    const {openModal} = useModal();

    const {isLoading, error, data} = useQuery([QueryKey.ApiKeys], async () => {
        const response = await getApiKeys();
        return response.data;
    }, queryConfig);

    const generateApiKey = async (e) => {
        e.preventDefault();
        openModal(<GenerateApiKeyModal />);
    }

    const removeKey = (e, key) => {
        e.preventDefault();
        openModal(<RemoveApiKeyModal apikey={key} />);
    }

    const editKey = (e, key) => {
        e.preventDefault();
        openModal(<EditApiKeyModal apikey={key} />);
    }

    return (
        <>
            {isLoading ? (
                <Throbber title="Loading Apikeys" />
            ) : error ? (
                <Error msg="Something went wrong loading API keys. Please try again later." />
            ) : data.apikeys && data.apikeys.length ? (
                <div className="table">
                    {data.apikeys.map((key, index) => {
                        return (
                            <div className="table__row" key={key.id}>
                                <div className="table__label">
                                    <span className="link" onClick={(e) => editKey(e, key)}>{key.name}</span>
                                </div>
                                <div className="table__value">
                                    {format(new Date(key.createdAt), 'EEEEEE dd LLL yyyy, HH:mm', {
                                        locale: enUS,
                                    })}
                                </div>
                                <div className="table__actions">
                                    <button className="button button--plain button--small button--icon" onClick={(e) => removeKey(e, key)}>
                                        <BinSVG/>
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            ) : (
                <div className="table">
                    <p>
                        No API keys yet
                    </p>
                </div>
            )}
            <button onClick={generateApiKey} className="button">Generate API Key</button>
        </>
    );
};

export default ApiKeys;
